import React from "react";

export default function AngleLeftSvg(Props) {
  return (
    <svg
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      onClick={Props.handleFunction}
      xmlns="http://www.w3.org/2000/svg"
      className={!Props.disabled ? "previousIcon" : "disablePreviousIcon"}
    >
      <g filter="url(#filter0_d_1929_16610)">
        <rect x="2" y="1" width="20" height="20" rx="10" fill="white" />
        <rect
          x="2.5"
          y="1.5"
          rx="9.5"
          width="19"
          height="19"
          stroke="#D0D5DD"
        />
        <path
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13.5 14L10.5 11L13.5 8"
          stroke={!Props.disabled ? "#667085" : "#D0D5DD"}
        />
      </g>
      <defs>
        <filter
          x="0"
          y="0"
          width="24"
          height="24"
          id="filter0_d_1929_16610"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1929_16610"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect1_dropShadow_1929_16610"
          />
        </filter>
      </defs>
    </svg>
  );
}
